export default "__VITE_ASSET__a7296949__"